(function() {
  window.Handsontable.Core.prototype.getRowOfSourceData = function(obj, guess) {
    var i, ref, row;
    if (guess == null) {
      guess = null;
    }
    if ((guess != null) && this.getSourceDataAtRow(guess) === obj) {
      return guess;
    }
    for (row = i = 0, ref = this.countRows() - 1; 0 <= ref ? i <= ref : i >= ref; row = 0 <= ref ? ++i : --i) {
      if (this.getSourceDataAtRow(row) === obj) {
        return row;
      }
    }
    return -1;
  };

}).call(this);
